import cloneDeep from 'clone-deep'
import { LayoutLoading } from 'components/LayoutLoading'
import { InputType } from 'config'
import { useSharedLoan } from 'context/SharedLoanContext'
import { useEffect, useState } from 'react'
import { getMers, updateMers } from 'services'
import { openAuditLog } from 'utils'
import { RenderInput } from 'utils/RenderInput'
import { setLoanNumber } from 'utils/setLoanNumber'

export default function Mers() {
  const shared = useSharedLoan()
  const isShared = !!shared?.readOnly
  const [isLoading, setLoading] = useState(false)
  const [inputs, setInputs] = useState<Record<string, InputType>>({})
  const [data, setData] = useState<Record<string, any>>({})
  const [orgData, setOrgData] = useState<Record<string, any>>({})

  const loanNumber = isShared ? shared.loanNumber : setLoanNumber()

  useEffect(() => {
    if (isShared) {
      const res = shared.pageData as any
      const nextInputs = cloneDeep(res?.inputs || {})
      Object.keys(nextInputs).forEach((key) => {
        nextInputs[key].disabled = true
        nextInputs[key].readOnly = true
        nextInputs[key].history = false
      })
      setInputs(nextInputs)
      setData(res?.data || {})
      setOrgData(res?.data || {})
      return
    }
    getMers().then(({ inputs, data }: { inputs: Record<string, InputType>; data: Record<string, any> }) => {
      Object.keys(inputs).forEach((key) => {
        inputs[key].history = true
      })
      setInputs(inputs)
      setData(data)
      setOrgData(data)
    })
  }, [isShared, shared?.pageKey, shared?.pageData])

  const onChange = (key: string, value: any) => {
    if (isShared) return
    const temp = cloneDeep(data)
    temp[key] = value
    setData(temp)
  }

  const onBlur = async (key: string, _value?: any) => {
    if (isShared) return
    const value = _value || data[key]
    if (orgData[key] == value) return

    setOrgData(data)

    setLoading(true)
    await updateMers(key, value)
    setLoading(false)
  }

  const onShowHistory = (key: string) => {
    if (isShared) return
    const options: Record<string, any> = {
      table: 'MERS',
      field: key,
      fieldLabel: inputs[key].title,
      keys: { field: key, loanNumber },
    }
    if (inputs[key].options) options.map = inputs[key].options
    openAuditLog(options)
  }

  return (
    <div className="Mers-container">
      <LayoutLoading show={isLoading} />
      <div className="grid gap-2 gap-y-4 md:grid-cols-4 sm:grid-cols-2 grid-cols-1">
        {Object.keys(inputs).map((key) => {
          const input = cloneDeep(inputs[key])
          input.value = data[key] !== undefined ? data[key] : input.value
          if (isShared) {
            input.disabled = true
            input.readOnly = true
          }

          return (
            <div key={key} className={`col-span-${input.span || 1}`}>
              <RenderInput
                input={input}
                Key={key}
                onChange={onChange}
                onBlur={onBlur}
                showHistory={isShared ? undefined : onShowHistory}
              />
            </div>
          )
        })}
      </div>
    </div>
  )
}
